module.exports = __webpack_public_path__ + "static/media/campus_32.6bda7a09.jpg";